import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { saveAs } from 'file-saver';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import S3 from "react-aws-s3";
import apis from '../../api';
import { Div, Form, FormGroup, Forms, Label } from './ProcessDian.styles';
import Video from '../Video/Video';
import { Link } from 'react-router-dom';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './ProcessDian.css'

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CompanyInfo
Description : Formulario de registro y configuración de la empresa
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
29/10/2021 Santiago Coca Rojas Modificación - Se agragan más propiedades a la creación de la compañía
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function ProcessDian(props) {

    /*Propiedades del componente*/
    const [processId, setProcessId] = useState('');
    const [dian, setDian] = useState('');
    const [testId, setTestId] = useState("");
    const [estado, setEstado] = useState("");
    const [codEstado, setCodEstado] = useState("");
    const [facturacion, setFacturacion] = useState("");
    const [usuario, setUsuario] = useState("");
    const [clave, setClave] = useState("");
    const [numeracionInicio, setNumeracionInicio] = useState("");
    const [numeracionFin, setNumeracionFin] = useState("");

    const [isOpen, setIsOpen] = React.useState(false);

    /*Listas de valores del componente*/
    const [listaDian, setListaDian] = useState([]);
    //const [listaEstado, setListaEstado] = useState([]);
    const [listaFacturacion, setListaFacturacion] = useState([]);

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loadPage, setLoadPage] = useState(false)

    /*Constantes globales del componente*/
    const headers = { Authorization: localStorage.getItem("token") }
    const elementWidth = { width: "20rem" }
    const labelStyle = { width: "28rem" }
    const cardStyle = {
        width: "100%", marginBottom: "1rem", justifyContent: "center",
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const fileUploadRef = useRef(null);
    const fileUploadRef2 = useRef(null);

    const toast = useRef(null);

    /*Funciones que manejan el comportamiento de los modales del componente*/
    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
        setLoading2(false);
    };

    useEffect(() => {
        const getLists = async () => {
            await apis.getListDIANProcess(headers).then(res => {
                let data = res.data;
                setListaDian(data["ENABLED_DIAN"]);
                //setListaEstado(data["PROCESS_STATUS"]);
                setListaFacturacion(data["USE_FT"]);
            })
        }
        getLists()
    }, [])

    useEffect(() => {
        const dianProcess = async () => {
            await apis.getDIANProcess(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let data = res.data;
                let _dian = data["ENABLED_DIAN"].split("|");
                let _facturacion = data["USE_FT"].split("|");
                let _estado = data["PROCESS_STATUS"].split("|");
                setProcessId(data["CONFIG_ID"]);
                setDian({ detail_id: _dian[0], description: _dian[1], code: _dian[2] });
                setTestId(data["TEST_SET_ID"]);
                setCodEstado(_estado[0]);
                setEstado(_estado[1]);
                setFacturacion({ detail_id: _facturacion[0], description: _facturacion[1] });
                setUsuario(data["USER"]);
                setClave(data["PASS"]);
                setNumeracionInicio(data["CONSEC_INI"]);
                setNumeracionFin(data["CONSEC_END"]);
                setLoadPage(true)
            })
        }
        dianProcess()
    }, [])

    useEffect(() => {
        const validateDian = async () => {
            await apis.validateDIANProcess(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                console.log(res.data)
                setLoadPage(true)
            }).catch(res => {
                setLoadPage(true)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.response.data.message, sticky: true });
            })
        }
        validateDian()
    }, []);

    // function validateForm() {
    //     /*Función que valida que los campos no sean nulos para poder realizar el proceso de enviar la información*/
    //     return tipoDocumento != null && documento != null && nombreEmpresa != null &&
    //         arl != null && banco != null && tipoCuenta != null && cuenta != null &&
    //         frecuencia != null && pais != null && departamento != null &&
    //         ciudad != null && exonerado != null && operador != null && celular != null;
    // }

    function handleSubmit(event) {
        event.preventDefault();
    }

    const showConfirm = (process) => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Solicitud {process} existosamente</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <Link style={{ textDecoration: 'none' }} to="/Employes">
                            <Button type="button" label="Continuar" className="p-button-success" />
                        </Link>
                    </div>
                </div>
            )
        });
    }

    async function postDIAN() {
        const _cliente = localStorage.getItem('client');
        const _entity = localStorage.getItem('entity');
        const _dian = dian.detail_id;
        const _facturacion = facturacion.detail_id;
        const _testId = testId;
        const _usuario = usuario;
        const _clave = clave;
        const _numeracionInicio = numeracionInicio
        const _numeracionFin = numeracionFin

        const data = {
            CLIENT: _cliente,
            ENTITY: _entity,
            ENABLED_DIAN: _dian,
            USE_FT: _facturacion,
            TEST_SET_ID: _testId,
            USER: _usuario,
            PASS: _clave,
            CONSEC_INI: _numeracionInicio,
            CONSEC_END: _numeracionFin
        }

        try {
            await apis.postDIANProcess(data, headers).then(res => {
                setLoading1(false);
                showConfirm("Creada")
            })
        }
        catch (err) {
            setLoading1(false);
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putDIAN() {
        const _cliente = localStorage.getItem('client');
        const _entity = localStorage.getItem('entity');
        const _dian = dian.detail_id;
        const _facturacion = facturacion.detail_id;
        const _testId = testId;
        const _usuario = usuario;
        const _clave = clave;
        const _numeracionInicio = numeracionInicio
        const _numeracionFin = numeracionFin

        const data = {
            CLIENT: _cliente,
            ENTITY: _entity,
            ENABLED_DIAN: _dian,
            USE_FT: _facturacion,
            TEST_SET_ID: _testId,
            USER: _usuario,
            PASS: _clave,
            CONSEC_INI: _numeracionInicio,
            CONSEC_END: _numeracionFin
        }

        try {
            await apis.putDIANProcess(data, headers).then(res => {
                showConfirm("Realizada")
                setLoading1(false);
            })
        }
        catch (err) {
            setLoading1(false);
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function processSelection() {
        if (processId) {
            putDIAN()
        }
        else {
            postDIAN()
        }
    }

    async function downloadManual() {
        /*Función encargada de descargar el manual instructivo para realizar el proceso de habilitación en la DIAN*/
        saveAs(process.env.REACT_APP_DIAN_MANUAL, "Habilitación_DIAN_FacturaTech.pdf");
        hideModal();
    }
    /*Header y footer del modal del componente*/
    const footer = (
        <div>
            <Button label="Descargar" loading={loading2} onClick={() => { setLoading2(true); downloadManual() }} />
        </div>
    );

    const header = (
        <div>
            <h3>Instructivo habilitación DIAN</h3>
        </div>
    )

    /*Footer del componente*/
    const cardFooter = <span>
        {processId && (codEstado !== "" && codEstado !== "2060") ?
            null
            : <Button label="Guardar" loading={loading1} style={{ marginTop: '-7rem' }} onClick={() => { setLoading1(true); processSelection() }} />}
    </span>

    /*Renderizado del componente*/
    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container">
            <Form onSubmit={handleSubmit}>
                <Dialog header={header} footer={footer} visible={isOpen} maximizable
                    position="top" style={{ width: "26rem" }} draggable={false} resizable={false} onHide={hideModal}>
                </Dialog>
                <Toast ref={toast} style={{ backgroundColor: 'white' }} />
                <div className="flex flex-row align-items-center justify-content-center mb-3 mt-5 font-bold text-4xl">
                    <span className="text-900">Proceso habilitación DIAN</span>
                    <Video header="Instructivo habilitación nómina electrónica" url={localStorage.getItem('PROCESSDIAN_VIDEO')} />
                </div>
                <SkeletonTable load={loadPage} width='80vw'>
                    <div className='flex justify-content-center'>
                        <Forms>
                            <Card style={cardStyle} footer={cardFooter}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">¿Está habilitado en la DIAN?</Label>
                                        <Dropdown className="dd1" value={dian}
                                            filter showClear filterBy="description"
                                            options={listaDian}
                                            onChange={(e) => {
                                                setDian(e.value);
                                                if (e.value !== undefined && e.value.detail_id == "2059") {
                                                    showModal();
                                                }
                                            }}
                                            disabled={processId && codEstado}
                                            emptyMessage={"No hay opciones disponibles"}
                                            placeholder="Seleccione" optionLabel='description'
                                        />
                                    </FormGroup>
                                    {dian !== undefined && facturacion !== undefined ? ((dian.detail_id === "2059") || (dian.detail_id == "2059" && facturacion.detail_id == "2054") || (dian.detail_id == "2058" && facturacion.detail_id === "2054") ?
                                        <FormGroup>
                                            <Label htmlFor="label">Test Set ID</Label>
                                            <InputText
                                                className="dd1"
                                                id="label3"
                                                type="text"
                                                value={testId}
                                                disabled={processId && (codEstado !== "" && codEstado !== "2060")}
                                                onChange={(e) => setTestId(e.target.value)}
                                            />
                                        </FormGroup> : null)
                                        : null}
                                </Div>
                                <Div>
                                    {dian !== undefined && dian !== '' ? (dian.code !== "" && dian.code !== "T" ?
                                        <FormGroup>
                                            <Label htmlFor="label">Estado</Label>
                                            <InputText
                                                className="dd1"
                                                id="label3"
                                                type="text"
                                                value={estado}
                                                disabled
                                                onChange={(e) => setEstado(e.target.value)}
                                            />
                                        </FormGroup> : null)
                                        : null}
                                    {dian !== undefined ? (dian.detail_id === "2058" || (dian.detail_id === "2059" && codEstado !== "") ?
                                        <FormGroup>
                                            <Label htmlFor="label">¿Usa FacturaTech como proveedor?</Label>
                                            <Dropdown className="dd1" value={facturacion}
                                                filter showClear filterBy="description"
                                                options={listaFacturacion} emptyMessage={"No hay opciones disponibles"}
                                                onChange={(e) => {
                                                    setFacturacion(e.value);
                                                    if (e.value !== undefined && e.value.detail_id == "2054") {
                                                        showModal();
                                                    }
                                                }}
                                                disabled={processId && codEstado}
                                                placeholder="Seleccione" optionLabel='description'
                                            />
                                        </FormGroup> : null)
                                        : null}
                                </Div>
                                {facturacion !== undefined && dian !== undefined ? (facturacion.detail_id === "2053" && dian.detail_id === "2058" ?
                                    <><Div>
                                        <FormGroup>
                                            <Label htmlFor="label">Usuario</Label>
                                            <InputText
                                                className="dd1"
                                                id="label3"
                                                type="text"
                                                value={usuario}
                                                disabled={processId && codEstado}
                                                onChange={(e) => setUsuario(e.target.value)}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="label">Clave</Label>
                                            <InputText
                                                className="dd1"
                                                id="label3"
                                                type="text"
                                                value={clave}
                                                disabled={processId && codEstado}
                                                onChange={(e) => setClave(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Div>
                                        <div style={{ marginBottom: "4rem", marginTop: "2rem" }} className="mb-3 font-bold text-1xl">
                                            <span className="text-900">Numeración disponible</span>
                                        </div>
                                        <Div>
                                            <FormGroup>
                                                <Label htmlFor="label">Inicio</Label>
                                                <InputText
                                                    className="dd1"
                                                    id="label3"
                                                    type="number"
                                                    value={numeracionInicio}
                                                    disabled={processId && codEstado}
                                                    onChange={(e) => setNumeracionInicio(e.target.value)}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label htmlFor="label">Fin</Label>
                                                <InputText
                                                    className="dd1"
                                                    id="label3"
                                                    type="number"
                                                    value={numeracionFin}
                                                    disabled={processId && codEstado}
                                                    onChange={(e) => setNumeracionFin(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Div></> :
                                    dian.code === "T" ?
                                        <>
                                            <div style={{ marginBottom: "4rem", marginTop: "2rem" }} className="mb-3 font-bold text-1xl">
                                                <span className="text-900">Numeración disponible</span>
                                            </div>
                                            <Div>
                                                <FormGroup>
                                                    <Label htmlFor="label">Inicio</Label>
                                                    <InputText
                                                        className="dd1"
                                                        id="label3"
                                                        type="number"
                                                        value={numeracionInicio}
                                                        disabled={processId && codEstado}
                                                        onChange={(e) => setNumeracionInicio(e.target.value)}
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label htmlFor="label">Fin</Label>
                                                    <InputText
                                                        className="dd1"
                                                        id="label3"
                                                        type="number"
                                                        value={numeracionFin}
                                                        disabled={processId && codEstado}
                                                        onChange={(e) => setNumeracionFin(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Div></>
                                        : null) :
                                    null}
                            </Card>
                        </Forms>
                    </div>
                </SkeletonTable>
            </Form>
        </div>
    );
}